/** Same key as `ConfigProvider` `useLocalStorage`. */
export const LAYOUT_PREFS_STORAGE_KEY = 'berry-config-vite-ts';

/** sessionStorage key prefix for one customize GET per tab session (cleared on logout). */
export const LAYOUT_PREFS_SESSION_CACHE_PREFIX = 'insight-layout-prefs-patch:v1:';

/** Match Insight `StaticConstants.FONT_SIZE_*` / MUI font slider. */
export const LAYOUT_FONT_SIZE_MIN_PX = 12;
export const LAYOUT_FONT_SIZE_MAX_PX = 22;
